import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataServiceService } from '../../services/qn-sbn-data-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtils } from '../../utlis/app-utils';
import { HttpErrorResponse } from '@angular/common/http';
import { snackbarService } from '@one/web-components';
import { NgIf } from '@angular/common';
import { CustomConfirmationDialogComponent } from '../../custom-confirmation-dialog/custom-confirmation-dialog.component';
import { FormsModule } from '@angular/forms';
import { SnackbarService } from '../../services/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDetailsService } from '../../notification/notification-details/notification-details.service'

@Component({
  selector: 'dl-button-action-bar',
  standalone: true,
  imports:[OneWebComponentsAngularModule,NgIf,FormsModule],
  templateUrl: './button-action-bar.component.html',
  styleUrl: './button-action-bar.component.scss',
  providers: [AppUtils],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ButtonActionBarComponent {

  public constructor(
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataServiceService,
    private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private _AppUtils:AppUtils,
    private snackBarNotification: SnackbarService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private notificationDetailsService: NotificationDetailsService
  ){}
  
  @Input() public btnState = {
    isPrevDisabled: true,
    isNextDisabled: false
  };
  
  
  @Output() public stepButton = new EventEmitter<{ isPrevState: boolean; isNextState: boolean }>();

  public isSendNotificationEnabled:boolean = true; 
  public isSendNotificationClicked:boolean = false; 
  public routerConfig = this.router.config.find(item => item.path === 'create-notification');
  public childPathArray;
  public isPrevDisabled = true;
  public isNextDisabled = true;
  public currentIndex = 1;
  public storedData;
  public userPermission: any;
  public titleNotification ='';
  public notificationId = '';
  public duplicates: any = [];
  public contactLimitNumber: number = 5000;
  public isButtonDisabled: boolean = false;
  public isLoading: boolean = false;
   public nonSavedFeedback: boolean = false;
  public isValid: boolean = false;
  public fbDisabledAndEnabled: boolean = false;
  public feedbackAdded: boolean = false;
   public feedbackEnabled: boolean = true;
  public enableDailyReport: boolean = true;
  public feedbackEdited: boolean = false;
   public DueDateEnabled: boolean = true;
    public DocumentEnabled: boolean = true;
  public hideActionBar: boolean = false;
  public confirmationDialogVisible: boolean = false;
  public confirmationDialogData = {
    title: 'Warning',
    message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
    confirmButtonText: 'Accept'
  };
  public deleteDialogVisible: boolean = false;
  public deleteDialogData = {
    title: 'Delete notification',
    message: 'Do you want to delete this draft notification?',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel'
  };
  
  public ngOnInit(): void {
    this._QnSbnDataService.hideActionBar$.subscribe(res => {
      this.hideActionBar = res;
      this.changeDetectorRef.detectChanges();
    });
    this.userPermission = this._QnSbnService.getUserData();
    
    this._QnSbnDataService.mappingData$.subscribe(storeData=>{
      this.storedData = storeData;
      this.btnSendNotificationEnabledCheck();
    })
   
    if(this.routerConfig){
      this.childPathArray =  this.routerConfig.children
        .map(item => item.path)
        .filter(path => path !== '**' && path !== '');
    }

    this.titleNotification = this.storedData.localNotificationId.LocalId;
    this.notificationId = this.storedData.localNotificationId.NotificationId;

    this._QnSbnDataService.DueDateEnabled$.subscribe(
      res =>{
        this.DueDateEnabled = res;
        this.btnSendNotificationEnabledCheck();
      } 
    )

     this._QnSbnDataService.FeedbackEnabled$.subscribe(
      res =>{
        this.feedbackEnabled = res;
      } 
    )

    this._QnSbnDataService.DailyReportEnabled$.subscribe(
      res =>{
        this.enableDailyReport = res;
        this.btnSendNotificationEnabledCheck();
      }
    )
    this._QnSbnDataService.DocumentEnabled$.subscribe(
      res =>{
        this.DocumentEnabled = res;
        this.btnSendNotificationEnabledCheck();
      } 
    )
  }

   public async saveCloseNotification(): Promise<void> {
    this.isButtonDisabled=true;
     await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
    await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
    await this._QnSbnDataService.setDRToggle(this.enableDailyReport);
    let saveNCloseData;

    this.nonSavedFeedback = this._QnSbnDataService.isAfoBtnDisabled$.value;
    this.isValid = this._QnSbnDataService.isValidFeedback$.value;
    this.fbDisabledAndEnabled = this._QnSbnDataService.fbDisabledAndEnabled$.value;
    this.feedbackAdded = this._QnSbnDataService.isFeedbackAdded$.value;
    this.feedbackEdited = this._QnSbnDataService.isEdited$.value;
   if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      const nonSavedFeedbackDialogRef = this.dialog.open(CustomConfirmationDialogComponent, {
      width: '600px',
      data: {
        title: 'Warning',
        message: 'You have changes not applied in the feedback form controls. Please apply them to continue.',
        confirmButtonText: 'Accept'
      }
    });
      nonSavedFeedbackDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      })
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
    }else{
      await this._QnSbnDataService.setDDToggle(this.DueDateEnabled);
      await this._QnSbnDataService.setFBToggle(this.feedbackEnabled);
      let saveNCloseData;
      if(!this._QnSbnDataService.isEmpty(this.storedData)){
        saveNCloseData = this._QnSbnDataService.saveNcloseData(this.storedData);
      }else{
        this.snackBarNotification.snackBarMessage('alarm', `Please add Feedback and click on Tick icon to Save and close`);
      } 
      
      let fileData = this._QnSbnDataService.fileUploadData(this.storedData); 
      sessionStorage.setItem('reloadOverview', 'true');
      if(fileData.length> 0){
        for(let f=0;f<=(fileData.length-1);f++){
          if(fileData[f].uploadFile) {
            await this._QnSbnService.dataToBeSaveOnS3(saveNCloseData,fileData[f],this.storedData['localNotificationId']['NotificationId'],(f==(fileData.length-1)) ? true :false, false);
          } else if(f==(fileData.length-1)){
            await this.saveNCloseApiCall(saveNCloseData);
          }
        } 
      } else {
        await this.saveNCloseApiCall(saveNCloseData);
      }
    }
    await new Promise(resolve => setTimeout(resolve, 5000));
    this.notificationDetailsService.setSelectedFilesToAdd([])
    this.changeDetectorRef.detectChanges();
  }


 
  public saveNCloseApiCall(saveNCloseData):void {
    this.isButtonDisabled = true;
    this._QnSbnService.saveNCloseNotificationData(saveNCloseData).subscribe(res=>{
      this._QnSbnDataService.resetAll();
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this.router.navigateByUrl('/notification');
      this.snackBarNotification.snackBarMessage('positive','Local notification saved successfully');
      
      },(error: HttpErrorResponse) => {
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this._QnSbnService.httpErrorHandler(error, 'Local notification not saved successfully');
    })
  }

  public getCurrentPathIndex(): number {
    const currentNavItem = this.router.routerState.snapshot.url.split('/').pop();
    return this.childPathArray.findIndex(x => x === currentNavItem);
  }

  public btnPrevNextStepClicked(step: string): void {
    this.nonSavedFeedback = this._QnSbnDataService.isAfoBtnDisabled$.value;
    this.isValid = this._QnSbnDataService.isValidFeedback$.value;
    this.fbDisabledAndEnabled = this._QnSbnDataService.fbDisabledAndEnabled$.value;
    this.feedbackAdded = this._QnSbnDataService.isFeedbackAdded$.value;
    this.feedbackEdited = this._QnSbnDataService.isEdited$.value;

    if((this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) || 
      (this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && !this.feedbackAdded) ||
      (!this.nonSavedFeedback && this.isValid && !this.fbDisabledAndEnabled && this.feedbackAdded && this.feedbackEdited) ||
      (!this.nonSavedFeedback && this.isValid && this.fbDisabledAndEnabled )){
      // Show the confirmation dialog
      this.confirmationDialogVisible = true;
      this._QnSbnDataService.isAfoBtnDisabled$.next(true);
      this._QnSbnDataService.fbDisabledAndEnabled$.next(false);
    }else{
    this.currentIndex = step === 'prev' ? this.getCurrentPathIndex() - 1 : this.getCurrentPathIndex() + 1;
    
    if (this.currentIndex === 0) {
      this.isPrevDisabled = true;
      this.btnState.isPrevDisabled = true;
      this.isNextDisabled = false;
      this.btnState.isNextDisabled = false;
    } else if (this.currentIndex === this.childPathArray.length - 1) {
      this.isNextDisabled = true;
      this.isPrevDisabled = false;
      this.btnState.isNextDisabled = true;
      this.btnState.isPrevDisabled = false;
    } else {
      this.isNextDisabled = false;
      this.isPrevDisabled = false;
      this.btnState.isNextDisabled = false;
      this.btnState.isPrevDisabled = false;
    }
   
    this.router.navigateByUrl(`/create-notification/` + this.childPathArray[this.currentIndex]).then(() => {
      this.stepButton.emit({ isPrevState: this.isPrevDisabled, isNextState: this.isNextDisabled });
      this.changeDetectorRef.detectChanges();
    });
  }
  }

  isValidDate(dateObject){
    return new Date(dateObject).toString() !== 'Invalid Date';
  }

  public btnSendNotificationEnabledCheck(): void {
    sessionStorage.setItem('reloadOverview', 'true');
    
    // Ensure storedData exists
    if (!this.storedData) {
      this.isSendNotificationEnabled = true;
      this.changeDetectorRef.detectChanges();
      return;
    }
    
  
    const documentToggleState = this.storedData?.documentEnabled ?? this.DocumentEnabled;
    let isDocumentValid = true;
    
    if (documentToggleState) {
     
      isDocumentValid = (this.storedData.notificationDoc && !this._QnSbnDataService.isEmpty(this.storedData.notificationDoc)) || 
                        (Array.isArray(this.storedData.notificationDocFileList) && this.storedData.notificationDocFileList.length > 0);
    }
    
    const dailyReportToggleState = this.enableDailyReport;
    let isDailySummaryValid = true;
    
    
    if (dailyReportToggleState) {
      const reportContent = this.storedData?.dailyReportContent;
      const hasReportContent = reportContent && 
                               Array.isArray(reportContent) && 
                               reportContent.length > 0;
      
      const sendToData = this.storedData?.dailyReportSendTo;
      const hasSendTo = sendToData && 
                        sendToData.sendTo && 
                        typeof sendToData.sendTo === 'string' &&
                        sendToData.sendTo.trim() !== '';
      
      // Validate email format
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValidEmail = hasSendTo && emailPattern.test(sendToData.sendTo);
      
      if (!hasReportContent && !hasSendTo) {
       
        isDailySummaryValid = true;
      } else if (hasReportContent && isValidEmail) {
       
        isDailySummaryValid = true;
      } else {
       
        isDailySummaryValid = false;
      }
    } else {
      
      isDailySummaryValid = true;
    
    }
    
 
    const dueDateToggleState = this.DueDateEnabled;
    let isDueDateValid = true;
    
    if (dueDateToggleState) {
      isDueDateValid = !this._QnSbnDataService.isEmpty(this.storedData.feedbackDueDate) && 
                       this.storedData.feedbackDueDate.feedbackDueDate &&
                       this.isValidDate(this.storedData.feedbackDueDate.feedbackDueDate);
    }
    const allValid = isDocumentValid
      && (!this._QnSbnDataService.isEmpty(this.storedData.recipientData) && Array.isArray(this.storedData.recipientData.recipientTable) && this.storedData.recipientData.recipientTable.length > 0 && this.storedData.recipientData.recipientTable.length <= this.contactLimitNumber && this.findDuplicates(this.storedData.recipientData.recipientTable).length <= 0 && this.findEmpties(this.storedData.recipientData.recipientTable).length <= 0)
      && (!this._QnSbnDataService.isEmpty(this.storedData.messageAttachment) && this.storedData.messageAttachment.subjectName && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "undefined" && this._AppUtils.extractContent(this.storedData.messageAttachment.messageAttachmentRTEText) !== "")
      && isDueDateValid
      && isDailySummaryValid;
    
    if(allValid){
      this.isSendNotificationEnabled = false; 
    }else{
      this.isSendNotificationEnabled = true; 
    }
    
    
    this.changeDetectorRef.detectChanges();
  }

  public btnSendNotificationClicked(): void {
    if (this.isSendNotificationClicked) {
      return;
    }
    this.isSendNotificationClicked = true;
    
    let sendNData;
    if(!this._QnSbnDataService.isEmpty(this.storedData)){
      sendNData = this._QnSbnDataService.saveNcloseData(this.storedData);
    } 

    let fileData = this._QnSbnDataService.fileUploadData(this.storedData); 
    sessionStorage.setItem('reloadOverview', 'true');
    if(fileData.length > 0){
      for(let f=0;f<=(fileData.length-1);f++){
        if(fileData[f].uploadFile) {
          this._QnSbnService.dataToBeSaveOnS3(sendNData,fileData[f],this.storedData['localNotificationId']['NotificationId'],(f==(fileData.length-1)) ? true :false, true);
        } else if(f==(fileData.length-1)){
          this.sendNotificationApiCall(sendNData);
        }
      }        
    } else {
      this.sendNotificationApiCall(sendNData);
    }
    this.notificationDetailsService.setSelectedFilesToAdd([])
    this.changeDetectorRef.detectChanges();
  }

  public sendNotificationApiCall(sendNData):void {
    this.isButtonDisabled = true;
    this._QnSbnService.sendNotificationData(sendNData).subscribe(res=>{
      this._QnSbnDataService.resetAll();
      this.isButtonDisabled = false;
      this.changeDetectorRef.detectChanges();
      this.router.navigateByUrl('/notification');
      this.snackBarNotification.snackBarMessage('positive', `Notification sent successfully`);

    },(error: HttpErrorResponse) => {
      this.isButtonDisabled = false;
      this.isSendNotificationClicked = false;
      this.changeDetectorRef.detectChanges();
      this._QnSbnService.httpErrorHandler(error, 'Sending local notification failed.');
    });
  }

 public discardDraftNotification(): void {
    // Show the delete confirmation dialog
    this.deleteDialogVisible = true;
  }

  public async onDeleteDialogConfirm(): Promise<void> {
    this.deleteDialogVisible = false;
    this.isButtonDisabled = true;
    
    this._QnSbnService.deleteDraftNotification(this.notificationId).subscribe(
      async (res) => {
        this.isButtonDisabled = false;
        await this.router.navigateByUrl('/notification');
        await this.snackBarNotification.snackBarMessage('positive', `The draft notification '${this.titleNotification}' deleted successfully`);
        await new Promise(resolve => setTimeout(resolve, 5000));
        this.notificationDetailsService.setSelectedFilesToAdd([])
        this.changeDetectorRef.detectChanges();
      },
      (error: HttpErrorResponse) => {
        this.isButtonDisabled = false;
        this._QnSbnService.httpErrorHandler(error, 'Please try again later');
      }
    );
  }

  public onDeleteDialogCancel(): void {
    this.deleteDialogVisible = false;
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) => 
        index !== targetIndex && 
        obj.customerId === target.customerId &&
        obj.customerEmail === target.customerEmail)
      )
      || (
        arr.some((obj, targetIndex)  => 
        index !== targetIndex && 
        obj.customerId === target.customerId && 
        obj.customerName !== target.customerName)
      ) ;
    });
  }

  public findEmpties(arr) {
    return arr.filter((i) => {
      return !i.customerContactName || !i.customerEmail || !i.customerId || !i.customerName || !i.sourceName ||
             i.customerContactName.trim() === '' || i.customerEmail.trim() === '' || 
             i.customerId.trim() === '' || i.customerName.trim() === '' || i.sourceName.trim() === '';
    });
  }

  public onConfirmationDialogClose(): void {
    this.confirmationDialogVisible = false;
  }
}

